/**
 * @generated SignedSource<<f236de665fd63c3b0d36aaa0503f38e6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LotTimer_saleArtwork$data = {
  readonly endAt: string | null | undefined;
  readonly extendedBiddingEndAt: string | null | undefined;
  readonly formattedStartDateTime: string | null | undefined;
  readonly lotID: string | null | undefined;
  readonly sale: {
    readonly extendedBiddingIntervalMinutes: number | null | undefined;
    readonly extendedBiddingPeriodMinutes: number | null | undefined;
    readonly internalID: string;
    readonly startAt: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "LotTimer_saleArtwork";
};
export type LotTimer_saleArtwork$key = {
  readonly " $data"?: LotTimer_saleArtwork$data;
  readonly " $fragmentSpreads": FragmentRefs<"LotTimer_saleArtwork">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LotTimer_saleArtwork",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "formattedStartDateTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extendedBiddingEndAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lotID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sale",
      "kind": "LinkedField",
      "name": "sale",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extendedBiddingPeriodMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extendedBiddingIntervalMinutes",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "internalID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SaleArtwork",
  "abstractKey": null
};

(node as any).hash = "55716d023ef3ebdf22143acc9c455550";

export default node;
